import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CookieConsent from '@/components/CookieConsent';

import HomePage from './pages/page';
import AdmMunicipalPage from './pages/adm-municipal/page';
import CepPage from './pages/cep/page';
import ComercioPage from './pages/comercio/page';
import ComercioCategoryPage from './pages/comercio/[category]/page';
import ContatoPage from './pages/contato/page';
import GuinchosPage from './pages/guinchos/page';
import HorariosOnibusPage from './pages/horarios-onibus-catanduvas/page';
import LanchesPizzasPage from './pages/lanches-pizzas/page';
import MarmitasPage from './pages/marmitas/page';
import NoticiasPage from './pages/noticias/page';
import PrivacidadePage from './pages/privacidade/page';
import SobrePage from './pages/sobre/page';
import TaxisPage from './pages/taxis/page';
import TermosPage from './pages/termos/page';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/adm-municipal" element={<AdmMunicipalPage />} />
        <Route path="/cep" element={<CepPage />} />
        <Route path="/comercio" element={<ComercioPage />} />
        <Route path="/comercio/:category" element={<ComercioCategoryPage />} />
        <Route path="/contato" element={<ContatoPage />} />
        <Route path="/guinchos" element={<GuinchosPage />} />
        <Route path="/horarios-onibus-catanduvas" element={<HorariosOnibusPage />} />
        <Route path="/lanches-pizzas" element={<LanchesPizzasPage />} />
        <Route path="/marmitas" element={<MarmitasPage />} />
        <Route path="/noticias" element={<NoticiasPage />} />
        <Route path="/privacidade" element={<PrivacidadePage />} />
        <Route path="/sobre" element={<SobrePage />} />
        <Route path="/taxis" element={<TaxisPage />} />
        <Route path="/termos" element={<TermosPage />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}
